import { useXappCoreAuthAdapter } from '#xapp-core/foundation/adapters/auth'

const rawAuthDisabled = String(
  import.meta.env.VITE_AUTH_DISABLED ?? 'false'
).toLowerCase()
const authDisabled =
  rawAuthDisabled === 'true' ||
  rawAuthDisabled === '1' ||
  rawAuthDisabled === 'yes'

export function usePermissionEvaluator() {
  const authStore = useXappCoreAuthAdapter()

  function hasPermission(ruleOrItem) {
    // When auth is disabled, treat all permission checks as allowed.
    if (authDisabled) return true
    if (!ruleOrItem) return true
    if (typeof ruleOrItem === 'string') return authStore.can(ruleOrItem)
    if (Array.isArray(ruleOrItem)) return authStore.canAny(ruleOrItem)
    if (typeof ruleOrItem === 'object') {
      if (ruleOrItem.perm) return authStore.can(ruleOrItem.perm)
      if (ruleOrItem.allPerm) return authStore.canAll(ruleOrItem.allPerm)
      if (ruleOrItem.anyPerm) return authStore.canAny(ruleOrItem.anyPerm)
      if (ruleOrItem.permissions)
        return authStore.canAny(ruleOrItem.permissions)
      return true
    }
    return true
  }

  return { hasPermission }
}
